import type { CandidateTier } from '../api/types';

export type DotTier = CandidateTier | 'baking' | 'failed';

/**
 * The per-option cache-tier indicator, straight from the prototype.
 *
 * In production green (device) and blue (catalog/pool) collapse into one calm
 * "ready" and amber reads as "made fresh just for them" — a parent must never
 * see COGS (hard line 8). The 4-way split below is the DEBUG view, which is
 * the whole reason this build exists.
 */
export function TierDot({ tier }: { tier: DotTier }) {
  const label =
    tier === 'baking'
      ? 'baking'
      : tier === 'device'
        ? 'on device — no network, no cost'
        : tier === 'catalog'
          ? 'platform catalog — no cost to you'
          : tier === 'pool'
            ? 'shared pool — no cost to you'
            : tier === 'generated'
              ? 'made fresh this session'
              : tier === 'failed'
                ? 'failed — tap to retry'
                : 'unknown tier';
  return <div className={`dot ${tier}`} title={label} />;
}

export function TierLegend() {
  return (
    <div className="legend">
      cache tier:
      <i style={{ background: 'var(--tier-device)' }} />
      on device
      <i style={{ background: 'var(--tier-catalog)' }} />
      catalog / shared pool
      <i style={{ background: 'var(--tier-generated)' }} />
      made fresh
      <i style={{ background: 'var(--tier-baking)' }} />
      baking
    </div>
  );
}
